import React from 'react';
import "./manageusers.css";
import DataTable from 'react-data-table-component';
import { faEye, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ManageContact = () => {
    const columns = [
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
            wrap:true
        },
        {
            name: 'Email',
            selector: row => row.email,
            sortable: true,
            wrap:true
        },
        {
            name: 'Phone Number',
            selector: row => row.number,
            sortable: true,
            wrap:true,
        },
        {
            name: 'Action',
            cell: row => (
                <div>
                    <FontAwesomeIcon icon={faEye} style={{ color: 'rgb(208, 38, 38)', cursor: 'pointer', marginRight: '10px' }} />
                    <FontAwesomeIcon icon={faTrash} style={{ color: 'rgb(208, 38, 38)', cursor: 'pointer' }} />
                </div>
            ),
            sortable: false,
            wrap:true,
        },
    ];

    const dummyData = [
        {
            name: 'Amit Das',
            email: "abc@gmail.com",
            number: "7908**4589",
        },
        {
            name: 'Ratan Das',
            email: "xyz@gmail.com",
            number: "7908**4589",
        },
        {
            name: 'Ankur Das',
            email: "abc@gmail.com",
            number: "7908**4589",
        },
    ];

    return (
        <div className='manageUsers' style={{ position: 'relative' }}>
            {/* Manage Contact text */}
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '20px 0' }}>
                <h3 style={{ fontSize: '20px' }}>Manage Contact</h3>
            </div>

            {/* Data table */}
            <DataTable
                className="dataTableContainer"
                columns={columns}
                data={dummyData}
                pagination
                highlightOnHover
                striped
                noHeader={true}
                customStyles={{
                    headCells: {
                        style: {
                            whiteSpace: 'normal', // Allow header text to wrap
                        },
                    },
                }}
            />

            {/* Footer */}
            <footer style={{ position: "fixed", bottom: "0", width: "100%",  padding: "10px 0" }}>
                <p style={{ fontSize: "12px", color: "#666" }}>Copyright © 2024 Psedge. All rights reserved.</p>
            </footer>
        </div>
    );
}

export default ManageContact;
